import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { memo, ReactNode, useContext } from 'react';

import { PageContext } from '../pages';

import Head from './head';
import Navigation from './navigation';
import { HEIGHT_OF_DESKTOP_HEAD_CONTAINER, HEIGHT_OF_MOBILE_HEAD_CONTAINER, HEIGHT_OF_MOBILE_SUBPAGES } from './consts';

interface StyleProps {
  includeSubpages: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    width: '100%',
    position: 'relative',
    height: `calc(100% - ${HEIGHT_OF_DESKTOP_HEAD_CONTAINER})`,
    [theme.breakpoints.down('sm')]: {
      height: ({ includeSubpages }: StyleProps) =>
        `calc(100% - ${HEIGHT_OF_MOBILE_HEAD_CONTAINER} - ${includeSubpages ? HEIGHT_OF_MOBILE_SUBPAGES : '0px'})`,
      top: ({ includeSubpages }: StyleProps) =>
        `calc(${HEIGHT_OF_MOBILE_HEAD_CONTAINER} + ${includeSubpages ? HEIGHT_OF_MOBILE_SUBPAGES : '0px'})`,
      paddingTop: theme.spacing(3)
    }
  }
}));

interface Props {
  children: ReactNode;
}

const WithLayout = ({ children }: Props) => {
  const { hasSubpages } = useContext(PageContext);
  const includeSubpages = hasSubpages === true;
  const classes = useStyles({ includeSubpages });

  return (
    <Box width="100%" height="100%" display="flex">
      <Navigation />
      <Box flexGrow="1" height="100%">
        <Head includeSubpages={includeSubpages} />
        <Box className={classes.content}>{children}</Box>
      </Box>
    </Box>
  );
};

export default memo(WithLayout);
